import { useRef } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from 'src/view/components/Controls/Icon/Icon';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import ModalPopup from 'src/view/components/ModalPopup/ModalPopup';
import './style.scss';

interface IProps {
  restrictionPosEdit?: RESTRICTION_ACCESS;
  restrictionPosDelete?: RESTRICTION_ACCESS;
  openEditModal: () => void;
  handleDelete: () => void;
}

const MealActionsPopup: React.FC<IProps> = (props: IProps): JSX.Element => {
  const modalRef = useRef<ModalPopup | null>(null);

  const changeVisibility = (visible: boolean) => {
    if (visible) {
      modalRef.current?.openModalPopup();
    } else {
      modalRef.current?.closeModalPopup();
    }
  };
  const renameSize = () => {
    changeVisibility(false);
    props.openEditModal();
  };

  const deleteSize = () => {
    changeVisibility(false);
    props.handleDelete();
  };

  return (
    <ModalPopup
      autoClose
      ref={modalRef}
      horizontal="end"
      content={
        <div className="meal-actions-popup__actions-list flex-1 p-4 animate__faster animate__animated animate__fadeInLeft">
          <IntegrationManager setting={props.restrictionPosEdit} tooltipOptions={{ minWidth: 355, position: TOOLTIP_POSITION.PORTAL }} withTooltip>
            <button onClick={renameSize} className="meal-actions-popup__btn-action p-0 m-0">
              <p className="family-medium text-size-18 color-dark text-start">{localeStore.t('rename')}</p>
            </button>
          </IntegrationManager>
          <IntegrationManager
            setting={props.restrictionPosDelete}
            wrapperClassName="mt-4"
            tooltipOptions={{ minWidth: 355, position: TOOLTIP_POSITION.PORTAL }}
            withTooltip
          >
            <button onClick={deleteSize} className="meal-actions-popup__btn-action p-0">
              <p className="family-medium text-size-18 color-dark text-start">{localeStore.t('txt_delete')}</p>
            </button>
          </IntegrationManager>
        </div>
      }
    >
      <button onClick={() => changeVisibility(true)} className="meal-actions-popup__btn-actions p-1 ml-2">
        <Icon name={Icons.MenuDots} size={18} color={theme.colors.dark} />
      </button>
    </ModalPopup>
  );
};

export default MealActionsPopup;
